import React from "react";
import { getProject } from "shared/selectors";
import { connect } from "react-redux";
import { string } from "prop-types";

function AdditionalProjectHtml({ __html }) {
  // Still unsecure bit Field is only controlled by Admins.
  // eslint-disable-next-line react/no-danger
  return __html && <div dangerouslySetInnerHTML={{ __html }} />;
}

AdditionalProjectHtml.propTypes = {
  __html: string.isRequired
};

function mapStateToProps(state) {
  return {
    __html: getProject(state).additional_html || ""
  };
}

export default connect(mapStateToProps)(AdditionalProjectHtml);
